import { Button, Grid, Typography } from "@mui/material";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import { Tag } from "components/Admin/Organizations/types/Module.type";
import AcxInputLabel from "components/UI/AcxInputLabel";
import React, { useEffect, useState } from "react";
import { FormFieldErrors } from "shared/types/FormErrors.type";
import OrganizationModuleDetailsSelection from "./OrganizationModuleDetailsSelection";
import theme from "Theme/AppTheme";

type Props = {
    value: any[];
    onChange: (val: Tag[]) => void;
    tagsLabel: string;
    error?: boolean;
    helperText?: string;
    errors?: FormFieldErrors;
    questionIndex: number;
    addTagsToDelete: (index: string) => void;
    errorPath: string;
    showInactive: boolean;
    isNew?: boolean;
    isScored?: boolean;
    showOverrideModuleScore?: boolean;
    isDefault?: boolean;
};

const OrganizationModuleDetailsSelections: React.FC<Props> = ({
    value,
    onChange,
    tagsLabel,
    error,
    helperText,
    errors,
    questionIndex,
    addTagsToDelete,
    errorPath = "",
    showInactive,
    isNew,
    isScored,
    showOverrideModuleScore,
    isDefault,
}) => {
    const [tags, setTags] = useState(value);

    useEffect(() => {
        onChange(tags);
    }, [onChange, tags]);

    const onChangeRow = (
        index: number,
        prop: string,
        val: string | number | boolean,
    ) => {
        setTags((prev) =>
            prev.map((row, rowIndex) =>
                rowIndex === index
                    ? {
                          ...row,
                          [prop]: val,
                      }
                    : row,
            ),
        );
    };

    const addRow = () => {
        setTags((prev) => {
            const newArr = [...prev];
            newArr.push({
                value: "",
                scoredValue: null,
                overrideModuleScore: false,
                isActive: true,
                isNew: true,
            });
            return newArr;
        });
    };

    const removeRow = (removeIndex: number, id: string) => {
        setTags((prev) => {
            const newArr = tags.filter((row, i) => i !== removeIndex);
            return newArr;
        });

        if (id) {
            addTagsToDelete(id);
        }
    };

    return (
        <Grid item xs={12} key={questionIndex} sx={{ marginTop: "1.75rem" }}>
            <Typography variant="h2" style={{ paddingBottom: "8px" }}>
                Tags
            </Typography>
            <Grid container spacing={1}>
                <Grid container justifyContent="center">
                    {!!value?.length &&
                        (showInactive
                            ? true
                            : value.some((item) => item.isActive)) && (
                            <table style={{ marginLeft: "-0.5rem" }}>
                                <thead>
                                    <tr>
                                        {!isDefault && (
                                            <th>
                                                <Typography
                                                    variant="h6"
                                                    align="center"
                                                >
                                                    {isNew === true
                                                        ? "Remove"
                                                        : "Active"}
                                                </Typography>
                                            </th>
                                        )}
                                        {showOverrideModuleScore && (
                                            <th>
                                                <Typography
                                                    variant="h6"
                                                    align="center"
                                                >
                                                    Override Module Score
                                                </Typography>
                                            </th>
                                        )}
                                        <th>
                                            <Typography
                                                variant="h6"
                                                align="center"
                                            >
                                                {isDefault ? " " : tagsLabel}
                                            </Typography>
                                        </th>

                                        {isScored && (
                                            <th>
                                                <Typography
                                                    variant="h6"
                                                    align="center"
                                                >
                                                    Score
                                                </Typography>
                                            </th>
                                        )}

                                        <th>
                                            <Typography
                                                variant="h6"
                                                align="center"
                                            >
                                                Order
                                            </Typography>
                                        </th>
                                        <th>
                                            <Typography
                                                variant="h6"
                                                align="center"
                                            >
                                                Sentiment
                                            </Typography>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!!value?.length &&
                                        value.map((row, i) =>
                                            showInactive ? (
                                                <tr key={i}>
                                                    <OrganizationModuleDetailsSelection
                                                        value={row}
                                                        onChange={onChangeRow.bind(
                                                            null,
                                                            i,
                                                        )}
                                                        addRow={
                                                            value.length ===
                                                            i + 1
                                                                ? addRow
                                                                : undefined
                                                        }
                                                        removeRow={removeRow.bind(
                                                            null,
                                                            i,
                                                            row.id,
                                                        )}
                                                        errors={errors}
                                                        questionIndex={
                                                            questionIndex
                                                        }
                                                        tagIndex={i}
                                                        errorPath={errorPath}
                                                        showInactive={
                                                            showInactive
                                                        }
                                                        isNew={isNew}
                                                        isScored={isScored}
                                                        showOverrideModuleScore={
                                                            showOverrideModuleScore
                                                        }
                                                        isDefault={isDefault}
                                                    />
                                                </tr>
                                            ) : (
                                                row.isActive && (
                                                    <tr key={i}>
                                                        <OrganizationModuleDetailsSelection
                                                            value={row}
                                                            onChange={onChangeRow.bind(
                                                                null,
                                                                i,
                                                            )}
                                                            addRow={
                                                                value.length ===
                                                                i + 1
                                                                    ? addRow
                                                                    : undefined
                                                            }
                                                            removeRow={removeRow.bind(
                                                                null,
                                                                i,
                                                                row.id,
                                                            )}
                                                            errors={errors}
                                                            questionIndex={
                                                                questionIndex
                                                            }
                                                            tagIndex={i}
                                                            errorPath={
                                                                errorPath
                                                            }
                                                            showInactive={
                                                                showInactive
                                                            }
                                                            isNew={isNew}
                                                            isScored={isScored}
                                                            showOverrideModuleScore={
                                                                showOverrideModuleScore
                                                            }
                                                            isDefault={
                                                                isDefault
                                                            }
                                                        />
                                                    </tr>
                                                )
                                            ),
                                        )}
                                </tbody>
                            </table>
                        )}
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={9}></Grid>
                    <Grid
                        item
                        xs={3}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button
                            color="secondary"
                            startIcon={<AddSharpIcon />}
                            sx={{
                                textTransform: "none",
                                fontWeight: "bold",
                                marginTop: "15px",
                            }}
                            onClick={addRow}
                            disabled={isDefault}
                        >
                            Add Tag
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            {helperText !== undefined && (
                <AcxInputLabel
                    id={"AcxText-BottomLabel"}
                    sx={{
                        fontFamily: theme.typography.fontFamily,
                        color: !error
                            ? theme.palette.text.primary
                            : `${theme.palette.error.main} !important`,
                        fontSize: "12px",
                        lineHeight: "16px",
                    }}
                    showAllErrors={true}
                >
                    {helperText}
                </AcxInputLabel>
            )}
        </Grid>
    );
};

export default OrganizationModuleDetailsSelections;
